import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";

// 初始化 dayjs 相对时间插件
dayjs.extend(relativeTime);
dayjs.extend(duration);

export const formatTime = (
  timestamp: number | Date | string,
  format: string = "MMM DD, YYYY"
): string => {
  return dayjs(timestamp).format(format);
};

export const formatDurationToMilliseconds = (seconds: number): string => {
  return dayjs.duration(Math.floor(seconds * 1000)).format("mm:ss.SSS");
};

export const formatDuration = (
  seconds: number,
  format: string = "mm:ss"
): string => {
  return dayjs.duration(Math.floor(seconds * 1000)).format(format);
};

export const formatRelativeTime = (
  timestamp: number | Date | string
): string => {
  return dayjs(timestamp).fromNow();
};
